import React from 'react';
import { connect } from 'react-redux';

export default function withToday(WrappedComponent) {
    return connect(
        ({ app }) => ({ ...app })
    )((props, state) => {
        return <WrappedComponent {...props} {...state} />;
    });
}